// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"53":"webfontloader","827":"new"}[chunkId] + "." + {"53":"6f7adfbd","827":"eed2e352"}[chunkId] + ".js";
};